import { ArrowLeft, Plus, Check, X } from "lucide-react";
import { Card } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/card";
import { Button } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/button";
import { useNavigate } from "react-router-dom";

const ConnectedDevices = () => {
  const navigate = useNavigate();

  const devices = [
    {
      name: "Fitbit Charge 5",
      status: "connected",
      lastSync: "2 mins ago",
      icon: "🏃",
      color: "bg-chart-1",
    },
  ];

  return (
    <div className="min-h-screen bg-background pb-24">
      <div className="mx-auto max-w-md space-y-4 p-4">
        {/* Header */}
        <div className="flex items-center justify-between pt-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate("/profile")}
            className="rounded-xl"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-xl font-bold text-foreground">
            Connected Devices
          </h1>
          <div className="w-10" />
        </div>

        {/* Connected Devices */}
        <div className="space-y-2">
          <h3 className="px-1 text-sm font-semibold uppercase tracking-wider text-muted-foreground">
            Connected
          </h3>
          {devices.map((device, index) => (
            <Card key={index} className="rounded-xl border-0 p-4 shadow-sm">
              <div className="flex items-center gap-4">
                <div
                  className={`h-12 w-12 rounded-xl ${device.color}/20 flex items-center justify-center text-2xl`}
                >
                  {device.icon}
                </div>
                <div className="flex-1">
                  <h4 className="font-medium text-foreground">{device.name}</h4>
                  <p className="text-sm text-muted-foreground">
                    Last synced: {device.lastSync}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <div className="h-2 w-2 animate-pulse rounded-full bg-secondary" />
                  <Check className="h-5 w-5 text-secondary" />
                </div>
              </div>
              <Button
                variant="outline"
                size="sm"
                className="mt-3 h-9 w-full rounded-lg border-destructive/30 text-destructive hover:bg-destructive/10"
              >
                <X className="mr-2 h-4 w-4" />
                Disconnect
              </Button>
            </Card>
          ))}
        </div>

        {/* Info Card */}
        <Card className="from-info/5 to-info/10 rounded-2xl border-0 bg-gradient-to-br p-5 shadow-sm">
          <h3 className="mb-2 font-semibold text-foreground">
            Why Connect Devices?
          </h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            Connecting your fitness devices allows Bite Balance to automatically
            sync your health data, providing you with comprehensive insights
            into your wellness journey. All data is securely encrypted and never
            shared without your permission.
          </p>
        </Card>
      </div>
    </div>
  );
};

export default ConnectedDevices;
